/*
  $emit
    setPtype
 */
<template>
  <div>
    <el-radio-group v-model="passwordType">
      <el-radio-button :label="0">初始密码</el-radio-button>
      <el-radio-button :label="1">自定义密码</el-radio-button>
    </el-radio-group>
    <el-popover placement="top-start" width="200" trigger="hover" content="密码需要包括：大小写字母、数字、特殊字符，长度在8-20个字符之间">
      <el-button type="text margin-left-little" slot="reference" style="margin-left: 10px;">
        <i class="el-icon-question grey"></i> 
      </el-button>
    </el-popover>
    <el-collapse-transition>
      <div v-show="passwordType == 1">
        <div class="form_box__item" style="margin-top:15px">
          <div class="form_box__item__input" style="width:450px">
            <el-input
              v-model="password"
              :type="inputPasswordType"
              placeholder="请填写密码"
              class="input_error"
              ref="input_password"
            >
              <template slot="prepend">新密码：</template>
            </el-input>
          </div>
        </div>

        <div class="form_box__item">
          <div class="form_box__item__input" style="width:450px">
            <el-input
              :type="inputPasswordType"
              v-model="rpassword"
              placeholder="再次填写密码以确认密码正确"
              class="input_error"
              ref="input_rpassword"
            >
              <template slot="prepend">再次输入新密码：</template>
            </el-input>
          </div>
        </div>

        <div class="form_box__item">
          <div class="form_box__item__input">
            <el-checkbox v-model="showpassword">显示密码</el-checkbox>
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "MuserPtypeSelect",
  
  mixins: [BaseVue],
  
  data() {
    return {
      passwordType: 0, // 密码类型 0 默认；1 自定义
      password: "", // 密码
      rpassword: "", // 重复密码
      inputPasswordType: "password", // input类型
      showpassword: false // 是否显示密码 false：不显示
    };
  },
  
  methods: {
    setPtype() {
      let params = {
        password: this.password,
        rpassword: this.rpassword,
        ptype: this.passwordType
      };
      this.$emit('setPtype', params);
    }
  },
  
  watch: {
    showpassword(newVal) {
      if (newVal) {
        this.inputPasswordType = "text";
      } else {
        this.inputPasswordType = "password";
      }
    },
    
    passwordType() {
      this.password = "";
      this.rpassword = "";
      this.setPtype();
    },
    
    password() {
      this.setPtype();
    },
    
    rpassword() {
      this.setPtype();
    }
  }
};
</script>

<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
</style>